import React from 'react'
import {
  TextField
} from '@material-ui/core';

const NonPharmacologicalRecommendations = ({nonPharmacologicalRecommendations, handleChange}) => {
  return (
    <TextField  label="Recomendaciones Generales Abreviadas"
      variant="outlined"
      name={'non_pharmacological_recommendations'}
      multiline
      fullWidth
      margin={'normal'}
      value={nonPharmacologicalRecommendations || ''}
      onChange={({target}) => handleChange(target)}
      type="text" />
  )
}

export default NonPharmacologicalRecommendations
